export const productsByTable = {
	label: "Salida de productos en mesa",
};
